import * as Logger from './logger.js'
import * as Utils from './utils.js';
import { HSCard } from './card.js';
import { UserSession } from './session.js';
import styles from './tiles.css';
import template from './tiles.html';
import openLinkImg from './img/open-link.svg';


export class HSTiles extends HSCard {
    items = [];
    itemsPerRow = 3;
    searchStr = "";

    constructor() {
        super();
    }

    onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
        this.showLoading();
    }

    onUnload() {
        super.onUnload();
        this.abort();
    }

    init(config) {
        super.init(config);
        this.reloadData();
    }

    search(str) {
        if (str != this.searchStr) {
            Logger.debug("Applying search filter: ", str);
            this.searchStr = str.toLowerCase();
            this.displayData();
        }
    }

    async reloadData() {
        // fetch the source data
        const json = await this.getSourceData(this.config.src);
        this.items = json;
        this.displayData();
        this.hideLoading();
    }

    displayData() {
        const gridContainer = this.shadowRoot.getElementById('tiles-grid');
        if (!gridContainer) {
            Logger.error("No grid container found");
            return;
        }

        const selectedProviders = UserSession.get('selected_providers') || [];
        const selectedIds = new Set(selectedProviders.map(x => (typeof x === 'string' ? x : (x?.id || x?.providerid))).filter(Boolean));

        const filteredItems = this.items.map(item => {
            // map the item to a tuple of { item, name }
            if (this.config.tileNameField) {
                if (Array.isArray(this.config.tileNameField)) {
                    for (const field of this.config.tileNameField) {
                        if (Utils.key_exists(item, field)) {
                            return { item, name: (item[field] ?? "").toString() };
                        }
                    }
                } else {
                    return { item, name: (item[this.config.tileNameField] ?? "").toString() };
                }
            }
            return { item, name: "" };
        }).filter(tuple => {
            // if search is set, filter items that don't match
            if (!tuple.name || !this.searchStr) {
                return true;
            }
            return tuple.name.toLowerCase().includes(this.searchStr);
        }).sort((a, b) => {
            // sort alpha-numerically
            return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
        });

        gridContainer.innerHTML = '';
        const rows = [];
        for (let i = 0; i < filteredItems.length; i += this.itemsPerRow) {
            rows.push(filteredItems.slice(i, i + this.itemsPerRow));
        }
        rows.forEach((row, rowIndex) => {
            const rowElement = document.createElement('div');
            rowElement.className = 'tiles-row';

            row.forEach((tuple, index) => {
                const { item, name } = tuple;
                const col = rowIndex * this.itemsPerRow + index;
                const colElement = document.createElement('div');
                const id = (this.config.tileIdField ? item[this.config.tileIdField] : item.id) || name;
                colElement.className = 'tile-item';
                if (selectedIds.has(id)) {
                    colElement.classList.add('selected');
                }

                // Add click handlers for this tile item
                if (this.config.onclick) {
                    this.onEvent('click', (opts, e) => {
                        this.runAction(this.config.onclick, { selected: { ...item, id, name }, item: { ...item, id, name } });
                    }, colElement);
                }

                const nameElement = document.createElement('div');
                nameElement.className = 'tile-name';
                nameElement.textContent = name;
                nameElement.title = name; // tooltip for overflow

                colElement.appendChild(nameElement);

                if (this.config.showIcon) {
                    const iconContainer = document.createElement('div');
                    iconContainer.className = 'link-icon';
                    const iconElement = document.createElement('img');
                    iconElement.src = openLinkImg;
                    iconContainer.appendChild(iconElement);
                    colElement.appendChild(iconContainer);
                }

                rowElement.appendChild(colElement);
            });

            gridContainer.appendChild(rowElement);
        });

        this.emit({ type: 'hs-data-count', count: filteredItems.length });
    }
}
customElements.define('hs-tiles', HSTiles);

